import { FaStar, FaStarHalfAlt } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";

const StarRating = ({
  rating = 0,
  maxStars = 5,
  size = 16,
  textSize = 'text-xs'
}) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.25 && rating % 1 <= 0.75;
  const emptyStars = maxStars - fullStars - (hasHalfStar ? 1 : 0);

  // For very small decimal values (e.g., 0.1) that shouldn't show as half star
  const showHalfStar = hasHalfStar || (rating % 1 > 0.75 && rating % 1 < 1);

  return (
   <div className="bg-white px-1 py-0.5 rounded-lg flex gap-1">
     <div className="flex items-center ">
      {[...Array(fullStars)].map((_, i) => (
        <FaStar size={size} key={`full-${i}`} className="text-yellow-400" />
      ))}

      {showHalfStar && (
        <FaStarHalfAlt size={size} key="half" className="text-yellow-400" />
      )}

      {[...Array(emptyStars)].map((_, i) => (
        <FaRegStar size={size} key={`empty-${i}`} className="text-[#E3E8F0]" />
      ))}
    </div>
     {rating !== 0 && <span className={`ml-1 text-gray-600 ${textSize} font-medium`}>{rating.toFixed(1)}</span>}
   </div>
  );
};

export default StarRating;
